import React, { forwardRef, useImperativeHandle, useState } from "react";
import Teachr from "src/Objects/models/Teachr";
import AddStudentDialog from "../../App/Clients/AddStudentDialog";
import { DispatchClientParams } from "../../config/CLIENT_TYPE_CONFIG";

export interface AddStudentDialogHandle {
    open: () => void;
}

interface AddStudentDialogTriggerProps {
    teachr: Teachr;
}

const AddStudentDialogTrigger = forwardRef<AddStudentDialogHandle, AddStudentDialogTriggerProps>(({ teachr }, ref) => {
    const [openStudent, setOpenStudent] = useState(false);

    useImperativeHandle(ref, () => ({
        open: () => setOpenStudent(true),
    }));

    const paramsData: DispatchClientParams = {
        teachrId: teachr?.id ? teachr.id : 0,
        archive: 0,
        page: 0,
        variable: 0,
        sort: 1,
        limit: 10,
        search: "",
    }

    return (
        <AddStudentDialog
            openView={openStudent}
            setOpenView={setOpenStudent}
            teachr={teachr}
            params={paramsData}
        />
    );
}
);

AddStudentDialogTrigger.displayName = "AddStudentDialogTrigger";
export default AddStudentDialogTrigger;
